import { useMemo } from 'react';

import { IAutoScrollSettings } from 'shared/components/Carousel/types';
import { useApplicationContext } from 'shared/utils/applicationContext';

export const useAutoScrollSettings = () => {
  const { config } = useApplicationContext();

  return useMemo(() => config.get<IAutoScrollSettings>('audience.carouselSettings.autoScroll') ?? undefined, [config]);
};
